import __trainTask from './trainTask';
export default __trainTask;
